import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import {
  SalesMyTarget, SalesTargetDto, SalesTargetMonthView, SalesTargetUpsert, SalesTeamBoard,
} from '../interfaces/sales/salesTarget.interface';

/** S2: monthly sales targets against actuals, and the Sales Manager / Sales Head board. `month` is yyyy-MM. */
export const SalesTargetService = {
  month: async (institutionId: string, month?: string): Promise<SalesTargetMonthView> =>
    (await axios.get(ENDPOINTS.SALES_TARGETS.MONTH(institutionId), { params: month ? { month } : {} })).data,
  my: async (institutionId: string, month?: string): Promise<SalesMyTarget> =>
    (await axios.get(ENDPOINTS.SALES_TARGETS.MY(institutionId), { params: month ? { month } : {} })).data,
  upsert: async (institutionId: string, body: SalesTargetUpsert): Promise<SalesTargetDto> =>
    (await axios.put(ENDPOINTS.SALES_TARGETS.UPSERT(institutionId), body)).data,
  remove: async (id: string): Promise<void> => {
    await axios.delete(ENDPOINTS.SALES_TARGETS.DELETE(id));
  },
  teamBoard: async (institutionId: string, month?: string): Promise<SalesTeamBoard> =>
    (await axios.get(ENDPOINTS.SALES_TARGETS.TEAM_BOARD(institutionId), { params: month ? { month } : {} })).data,
};

/** Current month (yyyy-MM) in Asia/Dhaka; never toISOString, which is UTC. */
export const currentDhakaMonth = (): string =>
  new Date().toLocaleDateString('en-CA', { timeZone: 'Asia/Dhaka' }).slice(0, 7);
